import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m19.87 7 1.22 2 .58 1H28v15H4V10h6.33l.58-1 1.22-2zm0-2h-7.74a2 2 0 0 0-1.71 1L9.2 8H7a1 1 0 0 0-2 0H4a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-5.2l-1.22-2a2 2 0 0 0-1.71-1" />
    <path d="M26 11a1 1 0 1 0 1 1 1 1 0 0 0-1-1m-10 1a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7" />
  </svg>
);
const ForwardRef = forwardRef(IconCameraOutlineSVG);
ForwardRef.displayName = "IconCameraOutline";
export { ForwardRef as IconCameraOutline };
